/* ==========================================================================
   MEET THE DOGS — gallery behaviour for the mtd-dog section
   Safe to load more than once: every gallery is flagged after it is wired up,
   and the theme editor's shopify:section:load event re-runs the init.
   ========================================================================== */
(function () {
  function initGallery(g) {
    if (g.dataset.mtdInit === 'true') return;
    g.dataset.mtdInit = 'true';

    var slides = Array.prototype.slice.call(g.querySelectorAll('.mtd-gal__slide'));
    var prev = g.querySelector('.mtd-gal__btn--prev');
    var next = g.querySelector('.mtd-gal__btn--next');
    var dotsWrap = g.querySelector('.mtd-gal__dots');
    var tag = g.querySelector('.mtd-gal__tag');
    var i = 0;

    if (!slides.length) return;

    if (slides.length < 2) {
      g.classList.add('mtd-gal--single');
      return;
    }

    // Build dots
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      slides.forEach(function (_, idx) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'mtd-gal__dot' + (idx === 0 ? ' is-active' : '');
        d.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
        d.addEventListener('click', function () { go(idx); });
        dotsWrap.appendChild(d);
      });
    }

    function go(n) {
      // Stop any playing iframe when leaving its slide
      slides.forEach(function (s, idx) {
        if (idx !== n && s.dataset.video !== undefined) {
          var iframe = s.querySelector('iframe');
          if (iframe && iframe.src) iframe.src = iframe.src; // reload to pause
        }
      });

      slides[i].classList.remove('is-active');
      if (dotsWrap && dotsWrap.children[i]) dotsWrap.children[i].classList.remove('is-active');

      i = (n + slides.length) % slides.length;

      slides[i].classList.add('is-active');
      if (dotsWrap && dotsWrap.children[i]) dotsWrap.children[i].classList.add('is-active');

      // Lazy-load video iframes only when entered
      if (slides[i].dataset.video !== undefined) {
        var active = slides[i].querySelector('iframe');
        if (active && !active.src && active.dataset.src) active.src = active.dataset.src;
      }

      if (tag) {
        tag.textContent = 'Field Media · ' + String(i + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
      }
    }

    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });

    // Touch swipe
    var startX = null;
    g.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    g.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
      startX = null;
    });

    // Keyboard support when gallery is focused
    g.tabIndex = 0;
    g.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(i - 1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { go(i + 1); e.preventDefault(); }
    });

    if (tag) tag.textContent = 'Field Media · 01 / ' + String(slides.length).padStart(2, '0');
  }

  function initAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var galleries = root.querySelectorAll('.mtd-gal');
    Array.prototype.forEach.call(galleries, initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Theme editor: re-wire a section after it is re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();
